import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('fragment', [_vm.label ? _c('Label', _vm._b({
    attrs: {
      "html-for": _vm.id,
      "bold": _vm.labelBold,
      "disabled": _vm.disabled
    }
  }, 'Label', _vm.labelProps, false), [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('DatePicker', {
    class: _vm.inputClass,
    attrs: {
      "lang": _vm.lang,
      "format": "DD/MM",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "clearable": "false",
      "range": "",
      "confirm": "",
      "confirm-text": "Buscar"
    },
    model: {
      value: _vm.data,
      callback: function callback($$v) {
        _vm.data = $$v;
      },
      expression: "data"
    }
  }), _vm.description ? _c('div', {
    staticClass: "input-description input-margin",
    class: _vm.descriptionClass
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };